

export enum PropertyType {
    HOUSE = "HOUSE",
    OFFICE = "OFFICE",
    INDUSTRY = "INDUSTRY",
    COMMERCIAL = "COMMERCIAL",
    APARTMENT = "APARTMENT",
    GARAGE = "GARAGE",
    OTHER = "OTHER",
    HOMES_TO_BUILD = "HOMES_TO_BUILD"
  }
  
export const ACCEPTABLE_PROPERTY_TYPES: string[] = Object.values(PropertyType);
  